import React, { useContext } from 'react';
import { LayoutContext } from 'contexts/LayoutContext';
import { UnionPayStackRoutes, UnionPayStackScreenProps } from '@/features/bill-payment/screens/union-pay/type';
import { SelectAccountWebScreen } from '@/features/bill-payment/screens/union-pay/SelectAccountWeb.screen';
import { SelectAccountNativeScreen } from '@/features/bill-payment/screens/union-pay/SelectAccountNative.screen';

export interface SelectAccountScreenProps {}

export const SelectAccountScreen: React.FC<UnionPayStackScreenProps<UnionPayStackRoutes.SelectAccount>> = ({ navigation, route }) => {
  const layout = useContext(LayoutContext);
  const { onLayout, onSelect, onBack, onChangeView } = route.params;

  if (layout.isMobile) {
    return <SelectAccountNativeScreen onSelect={onSelect} onBack={onBack} />;
  }
  return <SelectAccountWebScreen onLayout={onLayout} onBack={onBack} onSelect={onSelect} onChangeView={onChangeView} />;
};
